import { evalCondition, notifyParent } from 'mailup-react-helpers'

export const canUseMshop = () => {
  return evalCondition(
    'NOT c:IsRetailer AND uo:GEST AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP AND NOT c:IsOfferFrequenza'
  )
}

export const mshopBuy = () => {
  notifyParent('redirectMainFrame', [`mshop_Redirector.aspx?t=mshopem`])
}
